import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { PATH_KEY_TO_POSITION } from '../../constants';
import ProductList from '../ProductList';
import Panel from '../shared/Panel';
import CategoryEditor from './category-editor';

const LEVEL = PATH_KEY_TO_POSITION['categoryIdx'];

function CategoryItem(props) {
  const {
    category,
    menuIdx,
    categoryIdx,
    parent,
    setIsEditMode,
    isEditMode,
    isExpanded,
    setIsExpanded,
    isAnyChildItemExpanded,
  } = props;

  const [showCategoryEditor, setShowCategoryEditor] = useState(false);
  const toggleEditor = () => {
    setShowCategoryEditor(!showCategoryEditor);
    setIsEditMode(!showCategoryEditor);
  };

  return (
    <Panel
      key={`category-item-panel-${category.id}`}
      item={category}
      level={LEVEL}
      expandedDefault={category.expanded}
      onEdit={toggleEditor}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
      isAnyChildItemExpanded={isAnyChildItemExpanded}
    >
      {showCategoryEditor ? (
        <CategoryEditor
          parent={parent}
          category={category}
          menuIdx={menuIdx}
          categoryIdx={categoryIdx}
          onCancel={toggleEditor}
          setShowEditor={setShowCategoryEditor}
        />
      ) : (
        <ProductList
          menuIdx={menuIdx}
          categoryIdx={categoryIdx}
          parent={category}
          setIsEditMode={setIsEditMode}
          isEditMode={isEditMode}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
      )}
    </Panel>
  );
}

CategoryItem.propTypes = {
  parent: PropTypes.object.isRequired,
  categoryIdx: PropTypes.number.isRequired,
};

export default CategoryItem;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/CategoryList/category-item.jsx